export default __webpack_public_path__ + "static/media/necesidad.90e9344d.png";